<template>
  <div class="d-flex justify-center align-sm-center align-start" style="height: 100%">
    <v-card elevation="0" width="90%" max-width="600">
      <div class="mb-8">
        <img src="@/assets/logo.svg" class="mx-auto logo" />
      </div>
      <v-card-title class="d-flex justify-center flex-column">
        <div class="mainTitle font-weight-bold" style="font-size: 34px">{{ title }}</div>
      </v-card-title>
      <div style="height: 300px">
        <v-slide-x-transition mode="out-in">
          <div v-if="isPageLoading">
            <loading-mask :isLoading="true"></loading-mask>
          </div>
          <div v-else-if="tokenInvalid" class="pa-8 d-flex algin-center justify-center">
            <v-btn depressed type="submit" @click="goToLogin"> Back </v-btn>
          </div>
          <div v-else-if="successReset">
            <div class="text-center py-8 font-weight-bold">
              You can close this window or continue your work previously
            </div>
            <div class="d-flex justify-center align-center">
              <v-btn depressed type="submit" color="primary" @click="goToLogin">Login </v-btn>
            </div>
          </div>
          <v-form v-else key="resetForm" @submit.prevent="submit" ref="form" autocomplete="off">
            <v-container>
              <v-row dense>
                <v-col cols="12">
                  <v-text-field
                    v-model="password"
                    label="New Password"
                    outlined
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="passRules"
                    :type="showPassword ? 'text' : 'password'"
                    required
                    @click:append="showPassword = !showPassword"
                    autocomplete="off"
                    name="password"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="reEnterPassword"
                    label="Re-enter New Password"
                    outlined
                    :append-icon="showReEnterPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="rePassRules"
                    :type="showReEnterPassword ? 'text' : 'password'"
                    required
                    @click:append="showReEnterPassword = !showReEnterPassword"
                    autocomplete="off"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <div class="d-flex justify-center align-center">
                <v-btn type="submit" color="primary"> Submit </v-btn>
              </div>
              <div v-if="showErr" class="errMessage text-center">{{ showErr }}</div>
            </v-container>
          </v-form>
        </v-slide-x-transition>
      </div>
    </v-card>
  </div>
</template>

<script>
import api from '@/api';
import { ssoLogin, forgetPassword } from '@/api/auth/sso';
import { mapActions } from 'vuex';
import { rule_email } from '@/services/utils.js';
import { resetPasswordByToken } from '@/api/auth/sso';
import LoadingMask from '@/components/LoadingMask.vue';

export default {
  components: { LoadingMask },
  props: {
    token: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isPageLoading: true,
      tokenInvalid: false,
      successReset: false,

      rules: [
        value => !!value || 'Required.',
        //value => (value && value.length >= 1) || 'Min 1 characters',
      ],
      showPassword: false,
      showReEnterPassword: false,
      check: false,
      password: '',
      reEnterPassword: '',
      showErr: null,
      passRules: [
        value => !!value || 'Required.',
        //value => (value && value.length >= 8) || 'Min  characters',
      ],
      rePassRules: [value => value === this.password || 'Should same as New password.'],
      forgetUserEmail: null,
      emailRule: rule_email,
    };
  },
  computed: {
    title() {
      if (this.isPageLoading) return 'Loading';
      if (this.tokenInvalid) return 'Link expired or invalid';
      if (this.successReset) return 'SUCCESS';
      return 'RESET PASSWORD';
    },
  },
  beforeMount() {
    this.checkTokenValid();
  },
  methods: {
    ...mapActions('auth', ['checkLoginStatus']),
    async checkTokenValid() {
      try {
        const result = await resetPasswordByToken(api, null, { token: this.token });
      } catch (error) {
        if (error.statusCode === 401) {
          this.tokenInvalid = true;
        }
      } finally {
        this.isPageLoading = false;
      }
    },
    async submit() {
      if (!(await this.$refs.form.validate())) {
        return;
      }
      try {
        const result = await resetPasswordByToken(api, this.password, { token: this.token });
        this.successReset = true;
      } catch (err) {
        switch (err.message) {
          case 'invalid_access_token': {
            this.showErr = 'Password reset link expired or invalid. Contact support if needed.';
            break;
          }
          default:
            this.showErr = err.message;
        }
      } finally {
      }
      //   try {
      //     this.$refs.form.validate();
      //     const Credential = {
      //       auto: this.account,
      //       pw: this.password,
      //       remember: this.remember,
      //     };
      //     await ssoLogin(api, Credential);
      //     await this.checkLoginStatus();
      //     await this.$router.push(this.ret || '/').catch(() => {});
      //   } catch (err) {
      //     switch (err.message) {
      //       case 'Invalid Credentials': {
      //         this.showErr = 'Incorrect Password';
      //         break;
      //       }
      //       case 'Missing credentials': {
      //         if (this.account === '') this.showErr = 'Please enter username and password ';
      //         else this.showErr = 'Please enter password ';
      //         break;
      //       }
      //       default:
      //         this.showErr = err.message;
      //     }
      //   }
    },
    goToLogin() {
      this.$router.replace({
        name: 'login',
      });
    },
  },
};
</script>
<style lang="scss">
.errMessage {
  font-weight: 600;
  color: var(--v-danger-base);
}
</style>

<style lang="scss" scoped>
.logo {
  height: 300px;
  max-height: 30vh;
  max-width: 397px;
  width: 100%;
  object-fit: contain;
  display: block;
}
</style>
